"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserEventTypes = void 0;
var UserEventTypes;
(function (UserEventTypes) {
    UserEventTypes["USER_SIGNED_UP"] = "AUTH/USER_SIGNED_UP";
    UserEventTypes["USER_VERIFIED_EMAIL"] = "AUTH/USER_VERIFIED_EMAIL";
    UserEventTypes["USER_LOGGED_IN"] = "AUTH/USER_LOGGED_IN";
    UserEventTypes["USER_LOGGED_OUT"] = "AUTH/USER_LOGGED_OUT";
    UserEventTypes["USER_FORGOT_PASSWORD"] = "AUTH/USER_FORGOT_PASSWORD";
    UserEventTypes["USER_RESET_PASSWORD"] = "AUTH/USER_RESET_PASSWORD";
    UserEventTypes["USER_LOGGED_IN_SSO"] = "AUTH/USER_LOGGED_IN_SSO";
    UserEventTypes["USER_ENABLED_MFA"] = "AUTH/USER_ENABLED_MFA";
    UserEventTypes["USER_DISABLED_MFA"] = "AUTH/USER_DISABLED_MFA";
    UserEventTypes["USER_MFA_CHALLENGE"] = "AUTH/USER_MFA_CHALLENGE";
    UserEventTypes["USER_MFA_RECOVERY"] = "AUTH/USER_MFA_RECOVERY";
    UserEventTypes["USER_REPLACED_MFA_DEVICE"] = "AUTH/USER_REPLACED_MFA_DEVICE";
    UserEventTypes["USER_REQUESTED_MFA_CODES"] = "AUTH/USER_REQUESTED_MFA_CODES";
    UserEventTypes["USER_VIEWED_DETAILS"] = "AUTH/USER_VIEWED_DETAILS";
    UserEventTypes["USER_CHANGED_PASSWORD"] = "AUTH/USER_CHANGED_PASSWORD";
    UserEventTypes["USER_CHANGED_NAME"] = "AUTH/USER_CHANGED_NAME";
    UserEventTypes["USER_SESSION_RENEWED"] = "AUTH/USER_SESSION_RENEWED";
})(UserEventTypes || (exports.UserEventTypes = UserEventTypes = {}));
